
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { parseISO, format, isValid } from 'date-fns'
import Collapsible from 'Components/Collapsible'
import {
  _BuildingDetails, _DetailsContainer, _TitleValueBlock,
} from './styles'


const BuildingDetails = ({
  building,
  collapsibleIdSuffix,
}) => {
  const {
    developers, managements, title, name, registration_date: registrationDate, corporations,
  } = building || {}
  const date = registrationDate ? parseISO(registrationDate) : '-'
  const formattedDate = isValid(date) ? format(date, 'MMM d, y') : '-'
  const formattedCorps = corporations?.length > 0 ?
    corporations?.map((corp) => (`<span>${corp?.condo_corp}-${corp?.corp_number}</span>`)).join(' ') : '-'

  return (
    <_BuildingDetails>
      <Collapsible
        inputId={`BuildingDetails-${collapsibleIdSuffix}`}
        openCollapseTargetId={`BuildingDetails-${collapsibleIdSuffix}`}
        title={'Building Details'}
        gaActionTitle={'Building Details'}
        seoText={
          `Learn about building details of ${title || name || '-'}`
        }
        defaultShowState
        isCollapsible
        showSeparatorLine
      >
        <_DetailsContainer>
          <_TitleValueBlock
            title={'Developer'}
            value={developers?.length > 0 ? developers?.[0]?.name : '-'}
            url={developers?.length > 0 ? `/${developers?.[0]?.url}` : ''}
            valueIsLocked={false}
          />
          <_TitleValueBlock
            title={'Management'}
            value={managements?.length > 0 ? managements?.[0]?.name : '-'}
            url={managements?.length > 0 ? `/${managements?.[0]?.url}` : ''}
            valueIsLocked={false}
          />
          <_TitleValueBlock
            title={'Corp'}
            value={formattedCorps}
            valueIsLocked={false}
          />
          <_TitleValueBlock
            title={'Date Registered'}
            value={formattedDate}
            valueIsLocked={false}
          />
        </_DetailsContainer>
      </Collapsible>
    </_BuildingDetails>
  )
}


BuildingDetails.propTypes = {
  building: PropTypes.shape({
    ceiling_heights: PropTypes.string,
    building_type: PropTypes.string,
    smallest_unit: PropTypes.number,
    largest_unit: PropTypes.number,
    number_units: PropTypes.number,
    average_psf: PropTypes.number,
    floors: PropTypes.number,
    registration_date: PropTypes.string,
  }),
  collapsibleIdSuffix: PropTypes.string,
}

export default memo(BuildingDetails)
